export const isScheduleTimeInPast = (
    send_start: string,
    bufferTime: number,
) => {
    const nowUTC = Date.now();
    const scheduleUTC = new Date(send_start).getTime(); // always parsed as UTC if string contains Z or offset

    const minsDifference = (scheduleUTC - nowUTC) / 60000;
    return minsDifference <= bufferTime;
};
